<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f026-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The Liverpool Scottish Memorial Garden</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 39_chapter011.vue?1f626294